import React from 'react';
import { Table, Input, Button } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import { Modal } from 'react-bootstrap';

class TablePublicacoes extends React.Component {
  
  state = {
    showModalComentario: false,
    publicacaoSelecionada: "",
    colunas: [],
    data: []
  }

  componentDidMount () {
    if (this.props.contratos) {
      if (this.props.isContract) {
        this.prepareDataToColumns();
      } else {
        this.setState({data: this.props.contratos});
        this._renderDefaultColumns();  
      }
    }
  }

  identificarLabelCorrespondente (nota) {
    switch (nota) {
      case 0:
        return "---";
        break;
      case 1:
        return "Ruim";
        break;
      case 2:
        return "Bom";
        break;
      case 3:
        return "Ótimo";
        break;
      case 4:
        return "Excelente";
        break;
    }
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input 
          ref={node => {this.searchInput = node}} 
          placeholder={"Buscar por"} 
          value={selectedKeys[0]} 
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])} 
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)} 
          style={{width: 188, marginBottom: 8, display: "block"}}
        />
        <Button type="primary" onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)} icon={<SearchOutlined />} size="small" style={{width: 90, marginRight: 8}}>Pesquisar</Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>Cancelar</Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{color: filtered ? "#1890ff" : undefined}}/>,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => this.state.searchedColumn === dataIndex ? 
      (
        <Highlighter highlightStyle={{backgroundColor: "#ffc069", padding: 0}} searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };
  
  prepareDataToColumns () {
    let data = [];
    this.props.contratos.forEach((contrato) => {
      contrato.publicacoes.forEach((publicacao) => {
        data.push({
          dono: contrato.dono ? contrato.dono : this.props.designer,
          numero: contrato.numero, 
          id: publicacao.id, 
          tipoPublicacao: publicacao.tipo, 
          dataPublicacao: new Date(publicacao.dataPublicacao).toLocaleDateString("pt-br", {timezome: "UTC"}), 
          dataAprovacao: new Date(publicacao.dataAprovacao).toLocaleDateString("pt-br", {timezome: "UTC"}),
          notaAtendimento: this.identificarLabelCorrespondente(publicacao.pesquisas.notaAtendimento),
          notaDesign: this.identificarLabelCorrespondente(publicacao.pesquisas.notaDesign),
          comentario: publicacao.pesquisas.comentario,
          dataResposta: new Date(publicacao.pesquisas.dataResposta).toLocaleDateString("pt-br", {timezome: "UTC"})
        });
      });
    });
    this.setState({data});
    this._renderContractColumns();
  }

  _renderContractColumns () {
    let colunas = [
      {
        title: 'Contrato',
        dataIndex: 'numero',
        key: 'numero',
        ...this.getColumnSearchProps('numero')
      },
      {
        title: 'Publicação',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Tipo',
        dataIndex: 'tipoPublicacao',
        key: 'tipoPublicacao',
        ...this.getColumnSearchProps('tipoPublicacao')
      },
      {
        title: 'Designer',
        dataIndex: 'dono',
        key: 'designer',
        ...this.getColumnSearchProps('dono')
      },
      {
        title: 'Publicado em',
        dataIndex: 'dataPublicacao',
        key: 'dataPublicacao',
        ...this.getColumnSearchProps('dataPublicacao') 
      },
      {
        title: 'Aprovado em',
        dataIndex: 'dataAprovacao',
        key: 'dataAprovacao',
        ...this.getColumnSearchProps('dataAprovacao') 
      },
      {
        title: 'Pesquisa respondida em',
        dataIndex: 'dataResposta',
        key: 'dataResposta'
      },
      {
        title: 'Nota de Atendimento',
        dataIndex: 'notaAtendimento',
        key: 'notaAtendimento',
        ...this.getColumnSearchProps('notaAtendimento')
      },
      {
        title: 'Nota de Layout',
        dataIndex: 'notaDesign',
        key: 'notaDesign',
        ...this.getColumnSearchProps('notaDesign')
      },
      {
        title: 'Comentário',
        dataIndex: 'comentario',
        key: 'comentario',
        render: comentario => comentario ? <div onClick={() => {this.setState({showModalComentario: true})}} style={{marginLeft: 5, textDecoration: "underline", cursor: "pointer"}}>clique para ler</div> : "---"
      }
    ];
    this.setState({colunas});
  }

  _renderDefaultColumns () {
    let colunas = [
      {
        title: 'Número',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Tipo',
        dataIndex: 'tipo',
        key: 'tipo'
      },
      {
        title: 'Publicado em',
        dataIndex: 'dataPublicacao',
        key: 'dataPublicacao',
        render: dataPublicacao => new Date(dataPublicacao).toLocaleDateString("pt-br", {timezome: "UTC"})
      },
      {
        title: 'Aprovado em',
        dataIndex: 'dataAprovacao',
        key: 'dataAprovacao',
        render: dataAprovacao => new Date(dataAprovacao).toLocaleDateString("pt-br", {timezome: "UTC"})
      },
      {
        title: 'Pesquisa respondida em',
        dataIndex: 'pesquisas',
        key: 'pesquisas',
        render: pesquisas => new Date(pesquisas.dataResposta).toLocaleDateString("pt-br", {timezome: "UTC"})
      },
      {
        title: 'Avaliações',
        dataIndex: 'pesquisas',
        key: 'avaliacoes',
        render: pesquisas => <div key={pesquisas.id}>
          {pesquisas.notaAtendimento > 0 ? <span style={{display: "flex", alignItems: "center"}}><img src="/images/pesquisa-satisfacao/atendimento.png" style={{height: 13, marginRight: 5}}/> Nota de atendimento: {pesquisas.notaAtendimento}</span> : null} 
          <span style={{display: "flex", alignItems: "center"}}><img src="/images/pesquisa-satisfacao/layout.png" style={{height: 13, marginRight: 5}}/>Nota de layout: {pesquisas.notaDesign}</span> 
          {pesquisas.comentario ? <span style={{display: "flex", alignItems: "center"}}><img src="/images/pesquisa-satisfacao/comentario.png" style={{height: 13, marginRight: 5}}/>Comentário: <div onClick={() => {this.setState({showModalComentario: true})}} style={{marginLeft: 5, textDecoration: "underline", cursor: "pointer"}}>clique para ler</div></span> : null}
        </div>
      }
    ];
    this.setState({colunas});
  }

  render () {
    return (   
      <div>
        <Table 
          columns={this.state.colunas} 
          dataSource={this.state.data}
          onRow={(record) => { return { onClick: event => {this.setState({publicacaoSelecionada: record})}}}}
          onChange={this.handleChange}
          rowKey={record => record.id}
          bordered
        />
        <Modal show={this.state.showModalComentario !== false} onHide={()=>{this.setState({showModalComentario: false})}} dialogClassName="modal-80w">
          <Modal.Header>Comentário da publicação {this.state.publicacaoSelecionada.id}</Modal.Header>
          <Modal.Body><p style={{fontSize: 21}}>{this.state.publicacaoSelecionada ? this.state.publicacaoSelecionada.pesquisas ? this.state.publicacaoSelecionada.pesquisas.comentario : this.state.publicacaoSelecionada.comentario : ""}</p></Modal.Body>
          <Modal.Footer style={{display: "flex", justifyContent: "flex-end"}}><button className="btn btn-primary btn-flat" onClick={() => {this.setState({showModalComentario: false})}}>Fechar</button></Modal.Footer>
        </Modal>
      </div>         
    )
  }
}

export default TablePublicacoes;


// WEBPACK FOOTER //
// ./src/components/TablePublicacoes.js